import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { ApplicationStateHandlers } from './app.state.handlers';
import { AppSandbox } from './app.sandbox';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TwoColumnComponent } from './components/two-column/two-column.component';
import { AppDataService } from './app.data.service';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HeaderModule } from './components/header/header.module';
import { BootstrapGrowlModule } from './components/growl/bootstrap-growl.module';
import { ToastrModule } from 'ngx-toastr';
import { FooterModule } from './components/footer/footer.module';
import { ApiModule, BASE_PATH } from '../generated';
import { CommonModule } from '@angular/common';
// import { YouTubeService } from './services/youtube.service';
// @types/yt-player @types/youtube yt-player

@NgModule({
  declarations: [
    AppComponent,
    TwoColumnComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BootstrapGrowlModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      newestOnTop: false,
      onActivateTick: true,
      maxOpened: 2,
      // toastClass: "toastrStyling"
    }),
    AlertModule.forRoot(),
    CarouselModule.forRoot(),
    ButtonsModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    TabsModule.forRoot(),
    LazyLoadImageModule,
    HeaderModule,
    FooterModule,
    ApiModule,
    NgxsModule.forRoot([
      ApplicationStateHandlers
    ], { developmentMode: !environment.production }),
    NgxsStoragePluginModule.forRoot({
      key: ['app.cart', 'app.itineraries', 'app.currentItineraryId']
    }),
    NgxsLoggerPluginModule.forRoot({ collapsed: true }),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production })
  ],
  providers: [
    AppSandbox,
    AppDataService,
    { provide: BASE_PATH, useValue: '/api' }
    // YouTubeService
    // {
    //   provide: RouteReuseStrategy,
    //   useClass: CustomReuseStrategy
    // }
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
